<template>
  <div class="chat-app">
    <main class="chat-main">
      <header class="chat-header">
        <h2>Chat</h2>

        <!-- User selectors -->
        <div style="margin-top:10px; display:flex; gap:10px;">
          <label for="sender-id">Sender ID</label>
          <input v-model="senderId" placeholder="Sender ID" />
          <label for="receiver-id">Receiver ID</label>
          <input v-model="receiverId" placeholder="Receiver ID" />
          <input v-model="groupId" placeholder="Group ID (Optional)" />
          <button @click="startChat">Start Chat</button>
        </div>
      </header>

      <ul id="messages">
        <li
          v-for="msg in messages"
          :key="msg.id"
          :class="['message', msg.sender == senderId ? 'sent' : 'received']"
          :data-id="msg.id"
        >
          <div>{{ msg.content }}</div>

          <img
            v-if="msg.image"
            :src="'https://franciscopantry.com' + msg.image"
            style="max-width:200px;display:block;margin-top:5px"
          />

          <div
            v-if="msg.sender == senderId"
            class="status"
            style="font-size:11px;margin-top:5px;opacity:.7"
          >
            {{ msg.status || 'sent' }}
          </div>
        </li>
      </ul>

      <div class="input-area">
        <input v-model="content" placeholder="Type a message..." />
        <input type="file" @change="onFile" />
        <button @click="sendMessage">➤</button>
      </div>
    </main>
  </div>
</template>


<script>
import { io } from "socket.io-client";

export default {
  data() {
    return {
      senderId: "",
      receiverId: "",
      groupId: "",
      token: null,
      socket: null,
      messages: [],
      content: "",
      image: null,
      mode: "private" // private | group
    };
  },
  mounted() {
    if (!this.token) return console.error("Token missing");

    this.socket = io("https://115.84.243.189:5000/");

    this.socket.on("receive_message", (msg) => {
      this.messages.push(msg);
      this.scrollToBottom();
      if (!this.groupId) {
        this.socket.emit("delivered_confirm", { message_id: msg.id });
      }
    });

    this.socket.on("message_status", ({ message_id, status }) => {
      const m = this.messages.find(m => m.id === message_id);
      if (m) m.status = status;
    });

    this.socket.on("messages_read", ({ message_ids }) => {
      message_ids.forEach(id => {
        const m = this.messages.find(m => m.id === id);
        if (m) m.status = "read";
      });
    });
  },
  methods: {
    startChat() {
      if(this.groupId){
        this.startGroupChat()
      }else{
        this.startPrivateChat()
      }
    },

    async startPrivateChat() {
      console.log(this.groupId)
      if (!this.senderId || !this.receiverId) return alert("Enter sender & receiver");
      this.mode = "private";
      this.groupId = "";
      this.messages = [];
      this.socket.emit("register", this.senderId);
      await this.loadMessages();
    },

    async startGroupChat() {
      if (!this.senderId || !this.groupId) return alert("Enter sender & group ID");
      this.mode = "group";
      this.receiverId = "";
      this.messages = [];
      this.socket.emit("register", this.senderId);
      this.socket.emit("join_group", { group_id: this.groupId });
      await this.loadGroupMessages();
    },

    scrollToBottom() {
      this.$nextTick(() => {
        document.querySelector("#messages li:last-child")?.scrollIntoView({ behavior: "smooth" });
      });
    },

    async loadMessages() {
      const fd = new FormData();
      fd.append("sender_id", this.senderId);
      fd.append("receiver_id", this.receiverId);

      const res = await fetch("https://franciscopantry.com/chats", {
        method: "POST",
        headers: { Authorization: `Bearer ${this.token}` },
        body: fd
      });
      const data = await res.json();
      this.messages = data.data || [];
      this.scrollToBottom();
    },

    async loadGroupMessages() {
      const fd = new FormData();
      fd.append("user_id", this.senderId);
      fd.append("group_id", this.groupId);

      const res = await fetch("https://franciscopantry.com/group-chats", {
        method: "POST",
        headers: { Authorization: `Bearer ${this.token}` },
        body: fd
      });
      const data = await res.json();
      this.messages = data.data || [];
      this.scrollToBottom();
    },

    onFile(e) {
      this.image = e.target.files[0];
    },

    async sendMessage() {
      if (!this.content && !this.image) return;

      if (this.image) {
        const fd = new FormData();
        fd.append("sender_id", this.senderId);
        if (this.mode === "private") fd.append("receiver_id", this.receiverId);
        if (this.mode === "group") fd.append("group_id", this.groupId);
        if (this.content) fd.append("content", this.content);
        fd.append("image", this.image);

        const url = this.mode === "group"
          ? "https://franciscopantry.com/save-group-chat"
          : "https://franciscopantry.com/save-chat";

        const res = await fetch(url, {
          method: "POST",
          headers: { Authorization: `Bearer ${this.token}` },
          body: fd
        });
        const data = await res.json();
        this.socket.emit("send_message", { ...data.message, token: this.token });
      } else {
        console.log('message mode', this.mode)
        console.log('id', this.groupId)
        console.log('receiver id', this.receiverId)
        this.socket.emit("send_message", {
          sender_id: this.senderId,
          receiver_id: this.mode === "private" ? this.receiverId : null,
          group_id: this.mode === "group" ? this.groupId : null,
          content: this.content,
          token: this.token
        });
      }

      this.content = "";
      this.image = null;
    }
  }
};
</script>

